/**
 * FNV-1a, 64-bit, hex encoded.
 *
 * This is an integrity check, not a security hash: it exists so a blob truncated
 * by a failed save is rejected instead of being read back as valid course data.
 * It is synchronous by design — the store computes it inside a settings write,
 * where WebCrypto's promise-based API would force a save to straddle a tick.
 */
const OFFSET_BASIS = 0xcbf29ce484222325n;
const PRIME = 0x100000001b3n;
const MASK = 0xffffffffffffffffn;

export function checksum(input: string): string {
  let hash = OFFSET_BASIS;
  for (let i = 0; i < input.length; i += 1) {
    const code = input.charCodeAt(i);
    // Hash the UTF-16 code unit as two bytes so non-ASCII text still mixes in.
    hash = ((hash ^ BigInt(code & 0xff)) * PRIME) & MASK;
    hash = ((hash ^ BigInt((code >> 8) & 0xff)) * PRIME) & MASK;
  }
  return hash.toString(16).padStart(16, '0');
}

export function verifyChecksum(input: string, expected: string): boolean {
  return checksum(input) === expected;
}
